import {
  Dialog,
  DialogActions,
  Button,
  DialogContent,
  DialogTitle,
  TextField,
} from '@mui/material';
import { useState } from 'react';

type CustomTeamNameDialogProps = {
  currentTeamName?: string;
  onClose: () => void;
  onSubmit: (name: string) => void;
};

export const CustomTeamNameDialog = ({
  currentTeamName,
  onClose,
  onSubmit,
}: CustomTeamNameDialogProps) => {
  const [teamName, setTeamName] = useState(currentTeamName || '');

  return (
    <Dialog
      open
      onClose={onClose}
      PaperProps={{
        component: 'form',
        onSubmit: (event: React.FormEvent<HTMLFormElement>) => {
          event.preventDefault();
          const formData = new FormData(event.currentTarget);
          const formJson = Object.fromEntries((formData as any).entries());
          const { name } = formJson;
          onSubmit(name);
        },
      }}
    >
      <DialogTitle>Set custom team name</DialogTitle>
      <DialogContent>
        <TextField
          autoFocus
          required
          margin="dense"
          id="name"
          name="name"
          label="Team name"
          fullWidth
          variant="standard"
          defaultValue={currentTeamName}
          onChange={(event) => setTeamName(event.target.value)}
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button type="submit" disabled={!teamName}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};
